export default {"src":"/_next/static/media/courses.a3f58791.svg","height":239,"width":202};